/* global axios */
import ApiClient from './ApiClient';

/**
 * The assistant's note on one conversation. Singular on the server and singular here: a
 * conversation has exactly one note, rewritten in place, so there is nothing to list, nothing
 * to page through and no id to carry around.
 */
class AiNotesAPI extends ApiClient {
  constructor() {
    super('ai_note', { accountScoped: true });
    this.conversationId = null;
  }

  get url() {
    return `${this.baseUrl()}/conversations/${this.conversationId}/ai_note`;
  }

  /**
   * Answers { payload: null } for a conversation too short to have been summarised yet — a
   * state, not a miss, which is why nothing downstream treats an empty payload as a failure.
   * An account without the feature is refused with 403 { error }.
   */
  get(conversationId) {
    this.conversationId = conversationId;
    return axios.get(this.url);
  }

  /**
   * Rewrites the note now instead of waiting for the next few messages to trigger it. The
   * server runs it synchronously because an agent is sitting in front of it, and answers 503
   * with an { error } already written in their language when nothing could be produced.
   */
  refresh(conversationId) {
    this.conversationId = conversationId;
    return axios.post(`${this.url}/refresh`);
  }
}

export default new AiNotesAPI();
